export const connectIncludedFaqs = (data, included) => {
  let variants;
  if (data.attributes.category === 'cost') {
    variants = data.relationships.sibling_variants.data;
  } else {
    variants = data.relationships.variants.data;
  }

  let faqs = [];
  let treatmentInfos = [];
  let variantDetails = [];
  let treatmentImages = [];
  for (let i = 0; i < included.length; i += 1) {
    if (included[i].type === 'treatment_faq') {
      faqs = [...faqs, included[i]];
    } else if (included[i].type === 'treatment_info') {
      treatmentInfos = [...treatmentInfos, included[i]];
    } else if (included[i].type === 'treatment_image') {
      treatmentImages = [...treatmentImages, included[i]];
    }
  }


  variantDetails = [...variantDetails, variants.map(variant =>
    included.filter(item => item.id === variant.id))];

  return {
    ...data,
    faqs,
    treatmentInfos,
    variantDetails,
    treatmentImages
  };
};
